module.exports = __webpack_public_path__ + "static/media/remove-icon.195ec40a.png";